import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link, Redirect, useHistory } from "react-router-dom";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { CreatePaymentMethodData } from "@stripe/stripe-js";

import Loader from "../../shared/loader";
import AnonymousPage from "../anonymous-pages/anonymous-page";
import BoxWraper from "../box-wrapper";
import {
  payment,
  getCurrencies,
  clearRedirect,
  clearForm,
  clearRegistered,
  getPaymentIntent,
  setError,
  setPaying,
  setPaid,
  fetchPricingPlans,
  checkDiscountCode,
  getPaymentSession,
  setPaymentPaidForFreePricingPlan
} from "./ducks/actions";
import Form from "./form";
import { get } from "http";

function Payment(props) {
  const {
    paying,
    loadingPricingPlans,
    currencies,
    loadingCurrencies,
    errors,
    user,
    clearForm,
    registered,
    referralCode,
    clearRegistered,
    clientSecret,
    setError,
    setPaying,
    fetchPricingPlans,
    selectedCurrencyId,
    pricingPlans,
    selectedPricingPlan: defaultPricingPlan,
    noPaymentNeeded,
    pendingSetupIntent,
    checkDiscountCode,
    discountCodeValid,
    discountCodeDescription,
    checkingCode,
    firstMonthPrice,
    hasTax,
    getPaymentSession,
    sessionId,
    setPaymentPaidForFreePricingPlan
  } = props;

  const pricingPlanArgument = props.match.params.pricingPlan;

  const pricingPlan = defaultPricingPlan ?? pricingPlanArgument ? +pricingPlanArgument : 0;

  const history = useHistory();
  const [paymentMethodId, setPaymentMethodId] = useState("");
  const [selectedPricingPlan, setSelectedPricingPlan] = useState<any>(pricingPlan);

  useEffect(() => {
    clearForm();
    fetchPricingPlans();
    //getCurrencies();
  }, []);

  useEffect(() => {
    if (defaultPricingPlan) {
      setSelectedPricingPlan(defaultPricingPlan);
    }
  }, [defaultPricingPlan]);



  const onSetSelectedPricingPlan = (selectedPricingPlan) => {
    setSelectedPricingPlan(selectedPricingPlan);
  }

  // useEffect(() => {
  //   if (clientSecret) {
  //     const cardElement = elements.getElement(CardElement);
  //     const data: CreatePaymentMethodData = {
  //       type: "card", card: cardElement, billing_details: {
  //         name: userName,
  //         email: userEmailAddress,
  //         address: {
  //           country: userCountryCode
  //         }
  //       }
  //     };

  //     const getPaymentMethodRequest = async (data) => {
  //       const paymentMethodRequest: any = await stripe?.createPaymentMethod(data);
  //       if (paymentMethodRequest?.error) {
  //         throw paymentMethodRequest?.error.message;
  //       }
  //       const confirmedCardPayment = await stripe?.confirmCardPayment(clientSecret, { payment_method: paymentMethodRequest.paymentMethod.id })
  //       if (confirmedCardPayment?.error) {
  //         throw confirmedCardPayment?.error.message;
  //       }

  //       return confirmedCardPayment;
  //     }

  //     getPaymentMethodRequest(data).then(() => {
  //       setPaying(false);
  //       history.push("/payment/complete/" + pricingPlan);
  //     }).catch((error) => {
  //       setPaying(false);
  //       setError(error);
  //     });
  //   }
  // }, [clientSecret]);

  useEffect(() => {
    if (clientSecret) {
      //const cardElement = elements.getElement(CardElement);

      const data: any = {
        payment_method: paymentMethodId
      };

      const confirmCardSetup = async (data) => {
        try {
          const confirmedCardSetup = await stripe?.confirmCardSetup(clientSecret, data)
          if (confirmedCardSetup?.error) {
            throw confirmedCardSetup?.error.message;
          }

          return confirmedCardSetup;
        } catch (error) {
          debugger;
        }
      }

      const confirmCardPayment = async (data) => {
        try {
          const confirmedCardPayment = await stripe?.confirmCardPayment(clientSecret, data)
          if (confirmedCardPayment?.error) {
            throw confirmedCardPayment?.error.message;
          }

          return confirmedCardPayment;
        } catch (error) {
          debugger;
        }
      }

      if (pendingSetupIntent) {
        confirmCardSetup(data).then(() => {
          setPaying(false);
          history.push("/payment/complete/" + selectedPricingPlan);
        }).catch((error) => {
          setPaying(false);
          setError(error);
        });
      }
      else {
        confirmCardPayment(data).then(() => {
          setPaying(false);
          history.push("/payment/complete/" + selectedPricingPlan);
        }).catch((error) => {
          setPaying(false);
          setError(error);
        });
      }
    }
  }, [clientSecret]);

  const stripe = useStripe();
  const elements: any = useElements();

  useEffect(() => {
    if (sessionId) {
      setPaying(true);
      // Redirect to Stripe Checkout
      stripe?.redirectToCheckout({
        sessionId: sessionId
      }).then((result) => {
        if (result.error) {
          setPaying(false);
          setError(result.error.message);
        }
      }).catch((error) => {
        setPaying(false);
        setError(error.message);
      });
    }

  }, [sessionId]);

  useEffect(() => {
    if (noPaymentNeeded) {
      setPaying(false);
      history.push("/films");
    }
  }, [noPaymentNeeded]);

  if (pricingPlanArgument === "complete") {
    return null;
  }

  if (registered) {
    clearRegistered();
    return <Redirect to={`/confirmation/${selectedPricingPlan}`} />;
  }

  // const onPayment = async (pricingPlan, currencyId, discountCode) => {
  //   debugger;
  //   const cardElement = elements.getElement(CardElement);
  //   const userName = localStorage.getItem("userName") || user?.name || `${user?.firstName} ${user?.lastName}`;
  //   const userEmailAddress = localStorage.getItem("userEmailAddress") || user?.emailAddress || user?.email;
  //   const data: CreatePaymentMethodData = {
  //     type: "card", card: cardElement, billing_details: {
  //       name: userName,
  //       email: userEmailAddress,
  //       address: {
  //         country: userCountryCode
  //       }
  //     }
  //   };

  //   const getPaymentMethodRequest = async (data) => {
  //     const paymentMethodRequest: any = await stripe?.createPaymentMethod(data);
  //     if (paymentMethodRequest?.error) {
  //       throw paymentMethodRequest?.error.message;
  //     }

  //     return paymentMethodRequest;
  //     // const confirmedCardPayment = await stripe?.confirmCardPayment(clientSecret, { payment_method: paymentMethodRequest.paymentMethod.id })
  //     // if (confirmedCardPayment?.error) {
  //     //   throw confirmedCardPayment?.error.message;
  //     // }

  //     // return confirmedCardPayment;
  //   }

  //   getPaymentMethodRequest(data).then((response) => {

  //     const paymentMethodId = response?.paymentMethod?.id;
  //     setPaymentMethodId(paymentMethodId);
  //     getPaymentIntent(pricingPlan, currencyId, paymentMethodId, discountCode);
  //     //setPaying(false);
  //     //history.push("/payment/complete/" + pricingPlan);
  //   }).catch((error) => {
  //     setPaying(false);
  //     setError(error);
  //   });
  // }

  const onPayment = async (pricingPlan, currencyId, discountCode, totalPrice) => {
    if (pricingPlan === 0) {

      setPaymentPaidForFreePricingPlan();

      // set redirect to films page if this is sucessful

      return;
    } else {
      getPaymentSession(pricingPlan, currencyId, discountCode);
    }
  }

  const onCheckDiscountCode = (code, pricingPlan, currencyId) => {
    checkDiscountCode(code, pricingPlan, currencyId);
  }

  return (
    <AnonymousPage>
      <BoxWraper width={7}>

        {(loadingPricingPlans || loadingCurrencies || paying) && <Loader />}
        {!(loadingPricingPlans || loadingCurrencies) && <>
          {!registered && <Form
            errors={errors}
            loading={false}
            initialValues={user}
            handleSubmit={onPayment}
            currencies={currencies}
            showReferrer={referralCode == null}
            submitting={paying}
            defaultCurrencyId={selectedCurrencyId}
            pricingPlans={pricingPlans}
            hasTax={hasTax}
            selectedPricingPlan={selectedPricingPlan}
            setSelectedPricingPlan={onSetSelectedPricingPlan}
            noPaymentNeeded={noPaymentNeeded}
            checkDiscountCode={onCheckDiscountCode}
            discountCodeValid={discountCodeValid}
            discountCodeDescription={discountCodeDescription}
            checkingCode={checkingCode}
            firstMonthPrice={firstMonthPrice}
          />}
        </>}
      </BoxWraper>
    </AnonymousPage>
  );
}

function mapStateToProps(state) {
  const { accountState } = state;
  const { paymentState } = accountState;
  return {
    defaultCountryId: paymentState.defaultCountryId,
    currencies: paymentState.currencies,
    selectedCurrencyId: paymentState.selectedCurrencyId,
    selectedPricingPlan: paymentState.selectedPricingPlan,
    errors: paymentState.errors,
    loadingRegister: paymentState.loadingRegister,
    redirect: paymentState.redirect,
    clientSecret: paymentState.clientSecret,
    paying: paymentState.paying,
    pricingPlans: paymentState.pricingPlans,
    loadingPricingPlans: paymentState.loadingPricingPlans,
    userCountryCode: paymentState.userCountryCode,
    noPaymentNeeded: paymentState.noPaymentNeeded,
    pendingSetupIntent: paymentState.pendingSetupIntent,
    discountCodeValid: paymentState.discountCodeValid,
    discountCodeDescription: paymentState.discountCodeDescription,
    firstMonthPrice: paymentState.firstMonthPrice,
    checkingCode: paymentState.checkingCode,
    hasTax: paymentState.hasTax,
    sessionId: paymentState.sessionId
  };
}

export default connect(mapStateToProps, {
  clearForm,
  payment,
  getCurrencies,
  clearRedirect,
  clearRegistered,
  getPaymentIntent,
  setError,
  setPaying,
  fetchPricingPlans,
  checkDiscountCode,
  getPaymentSession,
  setPaid,
  setPaymentPaidForFreePricingPlan
})(Payment);
